export default "/images/sbn-logo.svg?391a1de86d79e65a821da69e90cd4d8e";